import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Country } from '@app/models/country';
import { CountryService } from '@app/services/shared/country.service';
import { MemberService } from '@app/services/member.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { Sort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { SortService } from '@app/components/sorting/SortService';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MenuItem, SelectItem } from 'primeng/api';
import { ReportService } from '@app/services/Reports/Report.service';
import { NavigationEnd, Router } from '@angular/router';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { Subscription } from 'rxjs/internal/Subscription';

interface District {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

interface IYear {
  year: number;
}

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

interface SignType {
  id: number;
  name: string;
}

interface Sign {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

interface GoodStandingResult {
  memberId: number;
  givenName: string;
  familyName: string;
  primaryLodge: string;
  currentLodge: string;
  currentLodgeName: string;
  currentLodgeType: string;
  year: number;
  feeAfterDiscount: number;
  //discount: number;
  yearBalance: number;
  payments: number; //FeeAfterDiscount - YearBalance
  email1: string;
  email2: string;
  webSite: string;
  initiationDate: string;
  createdDate: string;
  mentor: string;
  mentorId: number;
  birthday: string;
  isSubscriber: string;
  localId: number;
  institutionShortName: string;
  institutionName: string;
  institutionVisitingCity: string;
  institutionVisitingCountry: string;
  membershipStartDate: string;
  membershipEndDate: string;
  startCause: string;
  endCause: string;
  checked: boolean;
  phoneHome1: string;
  phoneHome2: string;
  phoneWork: string;
  phoneMobile: string;
}
interface MemberLabelInfo {
  //memberId: number;
  name: string;
  //familyName: string;
  homeCity: string;
  homeCountry: string;
  street: string;
  zipCode: string;
  //institutionId: number;
  //institutionShortName: string;
  //institutionName: string;
  careOf: string;
}

@Component({
  selector: 'app-gottstaende-ett-report',
  templateUrl: './gottstaende-ett-report.component.html',
  styleUrls: ['./gottstaende-ett-report.component.css']
})
export class GottstaendeEttReportComponent implements OnInit, OnDestroy {
  countries: Country[] = [];
  epost1: SelectItem[];
  epost2: SelectItem[];
  soft: SelectItem[];
  zipcodes: any[] = [];
  rangeValues: number[] = [1900, new Date().getFullYear()];
  displayMembershipInstitutions = false;
  displayNoMembershipInstitutions = false;
  selectedmembers: any[] = [];
  form;
  
  years: IYear[] = [];
  selectedyears: any[] = [];
  gsr: GoodStandingResult[] = [];
  districtlist: District[] = [];
  institutionbydistrictlist: Institution[] = [];
  institutionlist: Institution[] = [];
  signtypelist: SignType[] = [];
  signlist: Sign[] = [];
  officetypelist;
  officelist;
  committeelist;
  someorall: SelectItem[];
  expanded = true;
  expandedlabel = 'Stäng grupper';
  /************* Dateformat ****************************************/
  // maxYear ska sättas dynamiskt.
  minmaxyear = { minYear: '1920', maxYear: new Date().getFullYear() + 10 };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  membershipselectedinstitutions: any[] = [];
  nomembershipselectedinstitutions: any[] = [];
  items: MenuItem[];
  can_send_email = false;
  can_view_postals = false;
  se;
  showMailView: boolean = false;
  subscriptions: Subscription[] = [];
  // tslint:disable-next-line:max-line-length
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private countryService: CountryService,
    private memberService: MemberService,
    private institutionService: InstitutionsService,
    private memberofficeService: MemberofficeService,
    private datePipe: DatePipe,
    private reportService: ReportService,
    private snackBarService: SnackbarService,
    private permissionsService: PermissionsService) {
   
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
        
      }
    });
    this.countryService.countries$.subscribe(x => {
      if (x) {
        this.countries = x;
        
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      onlyActiveMembers: [true, ''],
      memberIdFrom: ['', ''],
      memberIdTo: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      zipCode: ['', ''],
      homeZipCodes: ['', []],
      homeCity: ['', ''],
      homeCountry: ['', ''],
      membershipCreatedFrom: ['', ''],
      membershipCreatedTo: ['', ''],
      membershipChangedFrom: ['', ''],
      membershipChangedTo: ['', ''],
      memberYear: [new Date().getFullYear(), ''],
  
      isSoftSubscriber: ['both', ''],
      membershipSomeOrAll: ['', ''],
      nomembershipSomeOrAll: ['', ''],
      membershipInstitutions: ['', ''],
      noMembershipInstitutions: ['', ''],
      membershipStartedFrom: ['', ''],
      membershipStartedTo: ['', ''],
      membershipEndedFrom: ['', ''],
      membershipEndedTo: ['', ''],
      noMembershipStartedFrom: ['', ''],
      noMembershipStartedTo: ['', ''],
      noMembershipEndedFrom: ['', ''],
      noMembershipEndedTo: ['', ''],
      parentInstitutionId: ['', ''],
      reportType: ['all', ''],
      institutionTypeId: ['', '']
    }, { validator: this.memberToValidator });
    
    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
    
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      // this.years.push({ year: i });
      this.years.push({ year: i });
      this.form.patchValue({ memberYear: this.years[0] });
    }
    this.epost1 = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    this.epost2 = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    this.soft = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    //this.someorall = [{ label: 'både', value: 'all' }, { label: 'någon av', value: 'some' }];
    this.someorall = [{ label: 'någon av', value: 'some' }];
    this.permissionsService.selectedrole.subscribe(r => {
      if (r) {
        this.setPermissions();
      }
    });
    //this.setPermissions();
    this.getAllDistricts();
    this.getAllInstitutions();
    this.getSignTypes();
    this.getSigns();

    this.getOfficesTypes();
    this.getOffices();
    this.getCommittees();
    this.setItems();

  }

  onSubmit() { }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        visible: this.gsr.length > 0,
        command: () => this.createLabels()
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope',
        command: () => this.sendMail(),
        visible: this.selectedmembers.length > 0 && this.can_send_email
      }];
  }

  
  setPermissions() {
    const userid = this.permissionsService.userid;
    const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_view_postals = user_permissions.indexOf('VIEW_POSTALS') !== -1;
    this.can_send_email = user_permissions.indexOf('SEND_EMAIL') !== -1;
    this.setItems();
    /*let can_view_postals_observable = this.permissionsService.hasPermissionForMember('VIEW_POSTALS', userid);
    let can_send_email_observable = this.permissionsService.hasPermissionForMember('SEND_EMAIL', userid);
    this.subscriptions.push(forkJoin([
      can_view_postals_observable,
      can_send_email_observable,
    ]).subscribe(response => {
      this.can_view_postals = response[0];
      this.can_send_email = response[1];
      this.setItems();
    }));*/
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
  }
  
  sendMail() {
    this.showMailView = true;
  }

  search() {
    const membershipinstitutions: number[] = [];
    this.membershipselectedinstitutions.forEach(i => {
      membershipinstitutions.push(i.id);
    });
    const nomembershipinstitutions: number[] = [];
    this.nomembershipselectedinstitutions.forEach(i => {
      nomembershipinstitutions.push(i.id);
    });
    this.form.get('membershipInstitutions').patchValue(membershipinstitutions);
    this.form.get('noMembershipInstitutions').patchValue(nomembershipinstitutions);
    this.reportService.GetGoodStanding1Report(this.form.value).subscribe(response => {
      if (typeof response === 'string') {
        this.gsr = [];
        this.snackBarService.openSnackBar(response, null, 'info', 5000);
      } else {
        this.gsr = response;
        let lastmemberid;
        this.gsr.forEach(mr => {
          mr['checked'] = false;

          if (mr.memberId !== lastmemberid) {
            mr['checkbox'] = true;
            lastmemberid = mr.memberId;
          }
        });
        this.setItems();
        //this.gsr = [];
       // alert(response);
      } /*else {
        this.gsr = response;
        this.setItems();
      }*/
    });
  }

  checkuncheckAll(element) {
    let value = false;
    let memberid;
    element.checked ? value = true : value = false;
    for (const m of this.gsr) {
      m.checked = value;
      if (m.memberId !== memberid) {
      this.add(m, element);
      }
      memberid = m.memberId;
    }
  }

  getOfficesTypes() {
    this.memberofficeService.GetOfficesTypes().subscribe(response => {
      this.officetypelist = response;
    });
  }

  setYears(evt) {

    const years: any[] = [];
    evt?.value.forEach(y => {
      years.push(y.year);
    });
    this.selectedyears = years;
    this.form.get('selectedYears').patchValue(years);
  }

  getOffices() {
    this.memberofficeService.GetOffices().subscribe(response => {
      this.officelist = response;
    });
  }

  clearSelectedYears() {
    this.form.patchValue({ selectedYears: [] });
  }

  getCommittees() {
    this.memberofficeService.Committees().subscribe(response => {
      this.committeelist = response;
    });
  }

  getAllDistricts() {
    this.memberService.getAllDistricts(0).subscribe(response => {
      // const fileNames = ['BL1', 'BL10', 'BL20', 'BL2', 'BL11'].sort(this.cmpStringsWithNumbers);
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  updateInstitutionList(event: any) {
    this.institutionService.GetInstitutionChildren(Number(event.target.value)).subscribe(response => {
      this.institutionbydistrictlist = response;
    });
  }

  getAllInstitutions() {

    this.institutionService.getInstitutions().subscribe(response => {


      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });

    });
  }

  getSignTypes() {
    this.memberService.getSignTypes().subscribe(response => {
      this.signtypelist = response;
    });
  }

  getSigns() {
    this.memberService.getSigns().subscribe(response => {
      if (response) {
        this.signlist = response;
      }
    });
  }

  clear() {
    this.form?.reset();
    this.zipcodes = [];
    this.form?.get('isSoftSubscriber').setValue('');
    this.form?.get('onlyActiveMembers').setValue(true);
    this.membershipselectedinstitutions = [];
    this.nomembershipselectedinstitutions = [];
    this.form?.patchValue({membershipInstitutions: []});
    this.form?.patchValue({noMembershipInstitutions: []});
    this.form?.patchValue({reportType: 'all'});
    this.form?.patchValue({memberYear: new Date().getFullYear()});
    this.form?.patchValue({isSoftSubscriber: 'both'});
    this.gsr = [];
    this.ngOnInit();
  }


  sortData(sort: Sort) {

    const data = this.gsr.slice();
    if (!sort.active || sort.direction === '') {
      this.gsr = data;
      return;
    }

    this.gsr = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'memberId': return this.compare(a.memberId, b.memberId, isAsc);
        case 'givenname': return this.compare(a.givenName, b.givenName, isAsc);
        case 'familyname': return this.compare(a.familyName, b.familyName, isAsc);
        case 'fullypaid': return this.compare(a.yearBalance >= 0, b.yearBalance >= 0, isAsc);
        case 'primaryLodge': return this.compare(a.primaryLodge, b.primaryLodge, isAsc);
        case 'currentLodge': return this.compare(a.currentLodge, b.currentLodge, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.memberId)) {
        this.selectedmembers.push(member);
        const idx = this.gsr.findIndex(m => m.memberId === Number(member.memberId));
        this.gsr[idx].checked = true;
      }
    } else {
      this.removeFromArray(member.memberId);
    }
    this.setItems();
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item.id === memberid);
  }

  removeFromArray(id: number) {
    const idx = this.selectedmembers.findIndex(item => item.id === id);
    this.selectedmembers.splice(idx, 1);
    const index = this.gsr.findIndex(m => m.memberId === id);
    if (index !== -1) {
      this.gsr[index].checked = false;
    }
  }

  createLabels() {
    let idlista: any[] = [];
    this.gsr.forEach(x => {
      idlista.push(x.memberId);
    });
    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {
        let memberlista: MemberLabelInfo[] = [];
        x.forEach(i => {
          const data = {
            name: i.givenName + ' ' + i.familyName,
            careOf: i.careOf,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;C/O;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_medlemmar';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }

  exportToCSV() {
    
    // tslint:disable-next-line:max-line-length
    const firstrow = 'Medlemsnr;Förnamn;Efternamn;Primärloge;Aktuell loge (kort);Aktuell loge;Logetyp;År;Årsavgift;Skuld(-) Fordran(+);Betalt totalt;Email1;Email2;Telefon hem 1;Telefon hem 2;Telefon jobb;Telefon mobil';
    //const firstrow = 'Medlemsnr;Förnamn;Efternamn;Primärloge;Aktuell loge;Logetyp;År;Årsavgift;Saldo;Betalt totalt;Email1;Email2;Telefon hem 1;Telefon hem 2;Telefon jobb;Telefon mobil';
    const datum = new Date();
    const filnamn = 'OF_Gottstaende1_' + datum.getFullYear() + datum.getMonth() + datum.getDay();
    CSVDataService.exportToCsv(filnamn + '.csv', this.gsr, firstrow);
  }

  setSelectedInstitutions(evt, institutionlist) {

    switch (institutionlist) {
      case 'membership': this.membershipselectedinstitutions = evt;
        const insts = [];
        evt.forEach(x => {
          if (x) {
            insts.push(x.id);
          }
        });
        this.form.patchValue({ membershipInstitutions: insts });
        break;
      /* case 'office': this.selectedinstitutions = evt;
         break;*/
    }

  }

  setSelectedNoInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'nomembership': this.nomembershipselectedinstitutions = evt;
        const insts = [];
        evt.forEach(x => {
          if (x) {
            insts.push(x.id);
          }
        });
        this.form.patchValue({ noMembershipInstitutions: insts });
        break;
    }
  }

  removeMembershipSelectedInstitution(id: number) {
    const idx = this.membershipselectedinstitutions.findIndex(x => x.id === id);
    this.membershipselectedinstitutions.splice(idx, 1);
    const insts = [];
    this.membershipselectedinstitutions.forEach(x => {
      if (x) {
        insts.push(x.id);
      }
    });
    this.form.patchValue({ membershipInstitutions: insts });
  }

  removeNoMembershipSelectedInstitution(id: number) {
    const idx = this.nomembershipselectedinstitutions.findIndex(x => x.id === id);
    this.nomembershipselectedinstitutions.splice(idx, 1);
    const insts = [];
    this.nomembershipselectedinstitutions.forEach(x => {
      if (x) {
        insts.push(x.id);
      }
    });
    this.form.patchValue({ noMembershipInstitutions: insts });
  }

  setDate(first, second) {
    const datum = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.form.get(first).patchValue(datum);
    this.form.get(second).patchValue(datum);
  }

  addZipCode() {
    let zipcode = this.form.get('zipCode').value;
    this.zipcodes.push(zipcode);

    this.form.patchValue({ homeZipCodes: this.zipcodes });
    this.form.patchValue({ zipCode: '' });
  }

  removeZipCode(zipcode) {

    const idx = this.zipcodes.findIndex(z => z === zipcode);

    this.zipcodes.splice(idx, 1);
  }

  memberToValidator(group: FormGroup) {
    const field1 = group.get('memberIdFrom');
    const field2 = group.get('memberIdTo');
    const membership = group.get('membershipSomeOrAll');
    if ((field1.value && !field2.value) || parseInt(field2.value) < parseInt(field1.value)) {
      field2.setErrors({ requiredIfField1Filled: true });
    } else if ((field2.value && !field1.value)) {
      field1.setErrors({ requiredIfField2Filled: true });
    } else if ((!membership.value)) {
      membership.setErrors({nomembership: true})
    }
    else {
      field2.setErrors(null);
      field1.setErrors(null);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => {
      x.unsubscribe();
    })
  }
}

